import { Link } from "react-router-dom";
import { Instagram, Heart } from "lucide-react";

/**
 * Sitewide footer — privacy, terms, contact, social, age disclaimer, copyright.
 * Used on Landing, Pricing, About, legal pages, etc.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      className="mt-20 border-t border-white/8 bg-black/30 backdrop-blur-sm"
      data-testid="site-footer"
    >
      <div className="max-w-5xl mx-auto px-6 py-10">
        {/* Top row: 18+ + tagline */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 mb-8">
          <div className="flex items-center gap-3">
            <span
              className="text-[10px] font-extrabold tracking-[0.3em] px-2 py-1 rounded-md bg-[#FF4D8D]/15 border border-[#FF4D8D]/40 text-[#FF4D8D]"
              data-testid="footer-age-badge"
            >
              18+
            </span>
            <span className="text-xs text-[#C9C7D9]">
              For couples · Some packs include adult content
            </span>
          </div>
          <a
            href="https://instagram.com/play.vibcheck"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-xs text-[#C9C7D9] hover:text-white transition-colors"
            data-testid="footer-instagram"
          >
            <Instagram className="w-4 h-4" />
            @play.vibcheck
          </a>
        </div>

        {/* Link grid */}
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
          <FooterLink to="/about" label="About" testid="footer-about" />
          <FooterLink to="/privacy" label="Privacy Policy" testid="footer-privacy" />
          <FooterLink to="/terms" label="Terms of Service" testid="footer-terms" />
          <FooterLink to="/refund-policy" label="Refund Policy" testid="footer-refund" />
          <FooterLink to="/contact" label="Contact" testid="footer-contact" />
          <FooterLink to="/pricing" label="Pricing" testid="footer-pricing" />
          <a
            href="mailto:playvibcheck@gmail.com"
            className="text-sm text-[#C9C7D9] hover:text-white transition-colors"
            data-testid="footer-email"
          >
            Support email
          </a>
          <a
            href="https://instagram.com/play.vibcheck"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm text-[#C9C7D9] hover:text-white transition-colors"
            data-testid="footer-instagram-link"
          >
            Instagram
          </a>
        </div>

        {/* Bottom: copyright */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 pt-6 border-t border-white/5">
          <p className="text-xs text-[#9B98AE]">
            © {year} VibeCheck. All rights reserved.
          </p>
          <p className="text-xs text-[#9B98AE] inline-flex items-center gap-1">
            Made with <Heart className="w-3 h-3 text-[#FF4D8D] fill-[#FF4D8D]" /> for couples
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterLink({ to, label, testid }) {
  return (
    <Link
      to={to}
      className="text-sm text-[#C9C7D9] hover:text-white transition-colors"
      data-testid={testid}
    >
      {label}
    </Link>
  );
}
